/*
 * File: QueryStatusErrorChecl.ts
 * Project: papa-bear
 * -----
 * Last Modified: 04 Jan 2022 2:09:05 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isFetchBaseQueryErrorType = (error: any): error is FetchBaseQueryError => {
  return 'status' in error && 'data' in error;
};
